import settings from '@/settings'

let atualizarImagemPerfil = (imagem, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/atualizarimagemperfil/`, {
    method: 'PUT',
    body: JSON.stringify(imagem),
    mode: 'cors',
    headers: headers
  })
}

let insert = (data, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let insertByPosto = (data, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/cadastrar_por_posto/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let atualizarEndereco = (data, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/atualizarendereco/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let atualizarEnderecoPorPosto = (data, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/atualizarenderecoporposto/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let atualizarUsuario = (data, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/atualizarusuario/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let auth = (headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const verificarTelefone = (headers, payload) => {
  return fetch(`${settings.apetrusApi}/pessoas/${payload.id_pessoa}/verificar-telefone/${payload.telefone}/?email=${payload.email}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const enviarEmailParaClientes = (data, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/emailforallusers/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

export default {
  atualizarUsuario,
  atualizarImagemPerfil,
  insert,
  insertByPosto,
  atualizarEndereco,
  atualizarEnderecoPorPosto,
  auth,
  verificarTelefone,
  enviarEmailParaClientes
}
